module.exports = __webpack_public_path__ + "img/operationCapacity5.2e0fbcc2.png";